var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_c('p',[_vm._v("\n    identyfikator wyexportowanego zip'a:\n    "+_vm._s(_vm.form.tasks_data['CREATE_ZIP']['input']['exported_svg_id'])+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }